import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faMousePointer } from "@fortawesome/free-solid-svg-icons"

export const MousePointer = (props) => {
  return <FontAwesomeIcon faIcon={faMousePointer} {...props} />
}
